import { render, staticRenderFns } from "./data-stock-stockist.vue?vue&type=template&id=5199bb0d&"
import script from "./data-stock-stockist.vue?vue&type=script&lang=js&"
export * from "./data-stock-stockist.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports